const DB_NAME = "_evol_spearup_db_1";
const DB_VERSION = 1; // ⬅️ ALWAYS bump when schema changes

const createLocalDb = () => {
  return new Promise((resolve, reject) => {

    if (!window.indexedDB) {
      reject("IndexedDB not supported");
      return;
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = (event) => reject(event);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

      const createStore = (name, options, indexes = []) => {
        if (!db.objectStoreNames.contains(name)) {
          const store = db.createObjectStore(name, options);
          indexes.forEach(i =>
            store.createIndex(i.name, i.keyPath, { unique: !!i.unique })
          );
        }
      };

	  createStore("_appLoginApi", { keyPath: "relationId" });
	  createStore("_hierarchyEmp", { keyPath: "empId" });
      createStore("_hierarchyRs", { keyPath: "relId" });
      createStore("_parentdictionary2", { keyPath: "eId" });
      createStore("_ccv1_getMasters", { keyPath: "masterId" });
      createStore("_groupsList", { keyPath: "groupId" });
      createStore("_groupContacts", { keyPath: "contactId" });
      createStore("_chatThreadByUserId", { keyPath: "chatId" });
      createStore("_historyApi", { keyPath: "campaignId" });
      createStore("_adsList", { keyPath: "id" });
	  
    };

    request.onsuccess = () => {
      request.result.close();
      //console.log("✅ IndexedDB ready");
      resolve(true);
    };
  });
};

export default createLocalDb;



